<template>
    <div>
        <div class="container">
            <p class="title">恭喜您已经通过路考！</p>
            <p>请与分公司联系，前往现场完成签约</p>
            <p class="tips">请携带本人身份证及驾驶证原件</p>
            <div class="QRcode">
                <qrcode></qrcode>
                <p>路考/签约时请出示二维码</p>
            </div>
        </div>
        <bottom-layout></bottom-layout>
    </div>
</template>
<script>
import qrcode from '../components/QRcode'
import BottomLayout from './BottomLayout'
export default {
  components: {
    BottomLayout,
    qrcode
  }
}
</script>
<style lang="scss" scoped>
.container{
    background: #f7f7f7;
    font-size: .28rem;
    color: #19191A;
    width: 86%;
    height: 7.506rem;
    margin-left: 3%;
    padding: 0 4% 0 4%;
    text-align: center;
    .title{
        text-align: center;
        margin-bottom: .32rem;
        padding-top: .65rem;
    }
    ul li:first-child{
        max-width: 30%;
        text-align: left;
        float: left;
        width: 1.4rem;
    }
    ul li:last-child{
        width: 70%;
        text-align: left;
        float: left;
    }
    li{
        display: inline-block;
    }
    ul{
         line-height: .44rem;
    }
    ul:after{
        content: '';
        display: block;
        clear: both;
    }
    .tips{
        font-size: .28rem;;
        color: #FF5548;
    }
}
.QRcode{
       width: 100%;
       text-align: center;
    p{
       font-size: .24rem;
        color: #19191A;
        padding-bottom: .2rem;
    }
}

</style>



// WEBPACK FOOTER //
// src/pages/pass-status/components/SignContract.vue